import clsx from 'clsx';
import { baseButtonClass } from '../index';
import { Triangle } from './Triangle';
import { RemoteButton } from '../../../../hooks/useRemote';

interface Props {
  buttons: RemoteButton[];
  onClick(commandId: number): void;
}

export const TVControls = ({ buttons, onClick }: Props) => {
  const classes = useStyles();
  const getButton = (position: number) =>
    buttons.find((button) => button.order === position);

  const handlePress = (position: number) => {
    const button = getButton(position);
    if (button === undefined) return undefined;
    return onClick(button.id);
  };

  return (
    <div className="col-span-full">
      <div
        className={clsx('grid grid-cols-4', {
          'gap-0': window.devicePixelRatio > 1,
          'gap-2': window.devicePixelRatio <= 1,
        })}
      >
        <Triangle
          disabled={Boolean(getButton(1)) === false}
          onClick={() => handlePress(1)}
          onTouchEnd={() => handlePress(1)}
          className="mb-4"
          direction="up"
          size="sm"
        />
        <button
          disabled={Boolean(getButton(2)) === false}
          onClick={() => handlePress(2)}
          onTouchEnd={() => handlePress(2)}
          className={clsx(
            baseButtonClass,
            'col-span-2 w-[80%] h-8 mx-auto mt-auto !rounded-full tracking-wide cursor-pointer',
            { 'scale-75': window.devicePixelRatio > 1 }
          )}
        >
          GUIDE
        </button>
        <Triangle
          disabled={Boolean(getButton(3)) === false}
          onClick={() => handlePress(3)}
          onTouchEnd={() => handlePress(3)}
          className="mb-4"
          direction="up"
          size="sm"
        />
        <div className="inline-flex w-full items-center justify-between col-span-full">
          <p className={classes.label}>VOLUME</p>
          <p className={classes.label}>CH/PG</p>
        </div>
        <Triangle
          disabled={Boolean(getButton(4)) === false}
          onClick={() => handlePress(4)}
          onTouchEnd={() => handlePress(4)}
          className="mt-4"
          direction="down"
          size="sm"
        />
        <button
          disabled={Boolean(getButton(5)) === false}
          onClick={() => handlePress(5)}
          onTouchEnd={() => handlePress(5)}
          className={clsx(
            baseButtonClass,
            'w-[80%] h-5 mx-auto mb-auto text-[0.46rem] tracking-wide overflow-hidden text-ellipsis',
            { 'scale-75': window.devicePixelRatio > 1 }
          )}
        >
          MUTE
        </button>
        <button
          disabled={Boolean(getButton(6)) === false}
          onClick={() => handlePress(6)}
          onTouchEnd={() => handlePress(6)}
          className={clsx(
            baseButtonClass,
            'w-[80%] h-5 mx-auto mb-auto text-[0.46rem] tracking-wide overflow-hidden text-ellipsis',
            { 'scale-75': window.devicePixelRatio > 1 }
          )}
        >
          LAST
        </button>
        <Triangle
          disabled={Boolean(getButton(7)) === false}
          onClick={() => handlePress(7)}
          onTouchEnd={() => handlePress(7)}
          className="mt-4"
          direction="down"
          size="sm"
        />
      </div>
    </div>
  );
};

const useStyles = () => ({
  label: 'text-[0.65rem] text-white',
});
